export default "__VITE_ASSET__D8gq64a___"